/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var padCountdownNumber = function(value) {
    return String(value).padStart(2, '0');
  };

  var updateProductCountdown = function(timer) {
    var endTime = new Date(timer.dataset.productCountdownEnd).getTime();

    if (!endTime) {
      timer.remove();
      return;
    }

    var remaining = endTime - Date.now();

    if (remaining <= 0) {
      timer.remove();
      return;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    var daysEl = timer.querySelector('[data-product-countdown-days]');
    var hoursEl = timer.querySelector('[data-product-countdown-hours]');
    var minutesEl = timer.querySelector('[data-product-countdown-minutes]');
    var secondsEl = timer.querySelector('[data-product-countdown-seconds]');

    if (daysEl) daysEl.textContent = padCountdownNumber(days);
    if (hoursEl) hoursEl.textContent = padCountdownNumber(hours);
    if (minutesEl) minutesEl.textContent = padCountdownNumber(minutes);
    if (secondsEl) secondsEl.textContent = padCountdownNumber(seconds);
  };

  var scanProductCountdowns = function(container) {
    (container || document).querySelectorAll('[data-product-countdown]').forEach(function(timer) {
      updateProductCountdown(timer);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scanProductCountdowns(document);
    });
  } else {
    scanProductCountdowns(document);
  }

  window.setInterval(function() {
    scanProductCountdowns(document);
  }, 1000);

  document.addEventListener('shopify:section:load', function(event) {
    scanProductCountdowns(event.target);
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ============================================================
   PRODUCT CARD VIDEO
   Shared cards appear in collections, search, featured collections,
   related products, complete-the-look, and homepage product sections.
   Play only cards near the viewport to protect initial page speed.
   ============================================================ */
(function () {
  function prepareCardVideo(container) {
    if (container.dataset.productCardVideoReady) return;
    container.dataset.productCardVideoReady = '1';
    var video = container.querySelector('video');
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var tryPlay = function () {
      if (document.hidden || !container.getClientRects().length) return;
      video.preload = 'auto';
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    };

    video.addEventListener('loadedmetadata', tryPlay);
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);
    window.addEventListener('pageshow', tryPlay);

    if (!('IntersectionObserver' in window)) {
      tryPlay();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tryPlay();
          window.setTimeout(tryPlay, 300);
          window.setTimeout(tryPlay, 1200);
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '250px 0px', threshold: 0.15 });
    observer.observe(container);
  }

  function scanProductCardVideos(root) {
    (root || document).querySelectorAll('[data-product-card-video]').forEach(prepareCardVideo);
  }

  document.addEventListener('lazyloaded', function (event) {
    var gifCard = event.target.closest && event.target.closest('[data-product-card-gif]');
    if (gifCard) gifCard.classList.add('product-card-gif-loaded');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanProductCardVideos(document); });
  } else {
    scanProductCardVideos(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scanProductCardVideos(event.target); });
})();

/* ============================================================
   PDP ANIMATED MEDIA
   - Reveal GIFs cleanly after the full asset decodes.
   - Load deferred videos shortly before they enter the viewport.
   - Explicitly apply Safari's muted/inline requirements and retry play.
   ============================================================ */
(function () {
  function prepareGif(gifSlide) {
    if (gifSlide.dataset.pdpGifReady) return;
    gifSlide.dataset.pdpGifReady = '1';
    var image = gifSlide.querySelector('[data-product-image]');
    if (!image) return;
    var reveal = function () { gifSlide.classList.add('pdp-gif-loaded'); };
    if (image.complete && image.naturalWidth > 0) reveal();
    else image.addEventListener('load', reveal, { once: true });
  }

  function configureVideo(video, slide) {
    if (!video || video.dataset.pdpAutoplayReady) return;
    video.dataset.pdpAutoplayReady = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');

    var attemptPlay = function () {
      if (document.hidden || !slide.getClientRects().length) return;
      var slider = slide.closest('[data-product-single-media-slider]');
      var isCarousel = slider && slider.classList.contains('flickity-enabled');
      if (
        document.hidden ||
        !slide.getClientRects().length ||
        (isCarousel && slide.classList.contains('media--hidden')) ||
        (isCarousel && !slide.classList.contains('is-selected'))
      ) return;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    };
    video.addEventListener('canplay', attemptPlay);
    video.addEventListener('loadeddata', attemptPlay);
    slide.addEventListener('theme:media:visible', attemptPlay);
    slide.addEventListener('theme:media:hidden', function () { video.pause(); });
    attemptPlay();
  }

  function loadVideo(slide) {
    if (slide.dataset.pdpVideoRequested) return;
    slide.dataset.pdpVideoRequested = '1';
    var slider = slide.closest('[data-product-single-media-slider]');
    if (
      window.matchMedia('(min-width: 768px)').matches &&
      slider &&
      !slider.classList.contains('flickity-enabled')
    ) {
      slide.classList.remove('media--hidden');
    }
    var button = slide.querySelector('[data-deferred-media-button]');
    if (button) button.click();

    var video = slide.querySelector('video');
    if (video) configureVideo(video, slide);
    else {
      var observer = new MutationObserver(function () {
        var insertedVideo = slide.querySelector('video');
        if (!insertedVideo) return;
        observer.disconnect();
        configureVideo(insertedVideo, slide);
      });
      observer.observe(slide, { childList: true, subtree: true });
    }
  }

  function initAnimatedMedia(root) {
    (root || document).querySelectorAll('.template-product [data-pdp-gif]').forEach(prepareGif);
    var slides = (root || document).querySelectorAll('.template-product [data-product-single-media-wrapper][data-video]');
    if (!slides.length) return;

    if ('IntersectionObserver' in window) {
      var viewportObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          viewportObserver.unobserve(entry.target);
          loadVideo(entry.target);
        });
      }, { rootMargin: '500px 0px', threshold: 0.01 });
      slides.forEach(function (slide) { viewportObserver.observe(slide); });
    } else {
      loadVideo(slides[0]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAnimatedMedia(document); });
  } else {
    initAnimatedMedia(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAnimatedMedia(event.target); });

  /* The base theme disables Flickity dragging whenever video playback starts.
     PDP videos autoplay, so that behavior would permanently lock mobile swipe. */
  document.addEventListener('theme:media:play', function (event) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var slider = event.target.closest('.template-product [data-product-single-media-slider]');
    if (!slider) return;

    /* Stop the base Product handler on the slide from setting draggable=false. */
    event.stopPropagation();

    var restoreDragging = function () {
      if (!window.themeVendor || !window.themeVendor.Flickity) return;
      var flickity = window.themeVendor.Flickity.data(slider);
      if (!flickity) return;
      flickity.options.draggable = true;
      flickity.updateDraggable();
      slider.classList.remove('has-media-active');
      slider.classList.remove('is-pointer-down');
    };

    restoreDragging();
    window.requestAnimationFrame(restoreDragging);
  }, true);
})();

/* ============================================================
   QUICKBUY SLIDER
   Builds a working horizontal carousel inside the Quick View
   popup. The popup HTML is injected via the Section Rendering
   API, so we use a MutationObserver to wire up the controls
   each time a new gallery shows up.
   ============================================================ */
(function () {
  var SLIDER_SELECTOR = '.popup-quick-view .product-single__media-slider';
  var INIT_FLAG = 'qbSliderReady';

  function initSlider(slider) {
    if (slider.dataset[INIT_FLAG]) return;
    var gallery = slider.closest('.popup-quick-view__gallery');
    if (!gallery) return;
    var slides = slider.querySelectorAll('.product-single__media-slide');
    if (!slides.length) return;
    slider.dataset[INIT_FLAG] = '1';
    if (slides.length < 2) {
      gallery.setAttribute('data-qb-single', '');
      return;
    }
    if (gallery.querySelector('.qb-slider-arrow')) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'qb-slider-arrow qb-slider-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 2 L4 6 L8 10"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'qb-slider-arrow qb-slider-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 2 L8 6 L4 10"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'qb-slider-dots';
    for (var i = 0; i < slides.length; i++) {
      var d = document.createElement('span');
      d.className = 'qb-slider-dots__dot' + (i === 0 ? ' qb-slider-dots__dot--active' : '');
      dots.appendChild(d);
    }

    gallery.appendChild(prev);
    gallery.appendChild(next);
    gallery.appendChild(dots);

    function currentIdx() {
      var w = slider.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / w)));
    }
    function update() {
      var idx = currentIdx();
      var children = dots.children;
      for (var i = 0; i < children.length; i++) {
        children[i].classList.toggle('qb-slider-dots__dot--active', i === idx);
      }
      prev.disabled = idx <= 0;
      next.disabled = idx >= slides.length - 1;
    }
    function go(delta) {
      var idx = currentIdx() + delta;
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      slider.scrollTo({ left: idx * (slider.clientWidth || 1), behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    update();
  }

  function scan() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ============================================================
   QUICKBUY: sync size pill highlight on first click
   The theme's popout JS at theme.js:4989-5000 only moves the FIRST
   "--current" class it finds when a size is clicked. The list items
   carry both .select-popout__item--current and .qb-popout__item--current,
   and only the former gets moved — leaving qb-popout__item--current on
   the previously selected item until the second click. This handler
   runs after the theme's listener (bubble phase) and rewrites
   .qb-popout__item--current to follow .select-popout__item--current,
   so the brown highlight tracks the actual variant on the first click.
   ============================================================ */
(function () {
  var ITEM_SELECTOR = '.qb-popout__item';
  var SELECT_CURRENT = 'select-popout__item--current';
  var QB_CURRENT = 'qb-popout__item--current';

  document.addEventListener('click', function (e) {
    var option = e.target.closest(
      '.popup-quick-view .selector-wrapper--qb-popout [data-popout-option], .popup-quick-view .selector-wrapper--size-dropdown [data-popout-option], .popup-quick-view .cherry-size-popout [data-popout-option]'
    );
    if (!option) return;

    var list = option.closest('.qb-popout__scroll, .select-popout__list__scroll');
    if (!list) return;

    list.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      item.classList.toggle(QB_CURRENT, item.classList.contains(SELECT_CURRENT));
    });
  });
})();

/* ============================================================
   SAFARI SIZE DROPDOWN & POPOUT FOCUSOUT SAFEGUARD
   In Safari (macOS & iOS), clicking or tapping on buttons and links
   does not move focus to the clicked element, causing focusout
   events to fire with event.relatedTarget === null. Without this
   safeguard, focusout listeners prematurely hide the dropdown list
   during mousedown, causing Safari to abort the click event and
   fail size selection across PDP, Quick View, and drawers.
   ============================================================ */
(function () {
  var isSafari = /Safari/i.test(navigator.userAgent) &&
    !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS|Android/i.test(navigator.userAgent);

  /* Safari can close the Quick View popout before its synthetic click reaches
     Palo Alto's handler. Select on pointerup, which works for mouse and touch. */
  if (isSafari) {
    document.addEventListener('pointerup', function (e) {
      var option = e.target.closest && e.target.closest(
        '.popup-quick-view .selector-wrapper--size-dropdown [data-popout-option]'
      );
      if (!option || option.closest('.sold-out, .unavailable')) return;

      var popout = option.closest('[data-popout]');
      var input = popout && popout.querySelector('[data-popout-input]');
      var list = popout && popout.querySelector('[data-popout-list]');
      var value = option.getAttribute('data-value');
      if (!input || value === null) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (list) {
        list.querySelectorAll('[aria-current]').forEach(function (item) {
          item.removeAttribute('aria-current');
        });
        list.querySelectorAll('[class*="--current"]').forEach(function (item) {
          Array.from(item.classList).forEach(function (className) {
            if (className.indexOf('--current') !== -1) item.classList.remove(className);
          });
        });
        option.setAttribute('aria-current', 'true');
        option.parentElement.classList.add('select-popout__item--current');
        list.classList.remove('select-popout__list--visible');
      }

      var text = popout.querySelector('[data-popout-text]');
      var toggle = popout.querySelector('[data-popout-toggle]');
      if (text) text.textContent = value;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }, true);
  }

  // Capture-phase focusout guard across all theme popouts and cherry size pickers
  document.addEventListener('focusout', function (e) {
    if (!e.relatedTarget && e.target.closest('[data-popout-list], [data-popout], [data-cherry-size-picker]')) {
      e.stopImmediatePropagation();
    }
  }, true);

  // Reliable outside-tap dismiss for open popout lists on touch devices
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest('[data-popout], [data-cherry-size-picker]')) return;
    document.querySelectorAll('.select-popout__list--visible').forEach(function (list) {
      list.classList.remove('select-popout__list--visible');
      var toggle = list.closest('[data-popout]')?.querySelector('[data-popout-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ============================================================
   QUICKBUY: move title / price / size selector into the foot
   Color swatches stay in __body so the theme's swatch-init JS
   keeps working — only the title, price, and the custom size
   popout (which we built ourselves) are reparented.
   ============================================================ */
(function () {
  var ITEM_SELECTOR = '.popup-quick-view [data-quick-view-item]';
  var DONE_FLAG = 'qbReorganized';

  function reorganize(item) {
    if (item.dataset[DONE_FLAG]) return;
    var footInner = item.querySelector('.popup-quick-view__foot__inner');
    var submitHolder = item.querySelector('.product__submit__holder');
    if (!footInner || !submitHolder) return;

    var title = item.querySelector('.popup-quick-view__title');
    var priceBlock = item.querySelector('.popup-quick-view__body .product__block.product__price-and-badge');
    // The .selector-wrapper--size-dropdown is the custom size popout we
    // build for the quickview only. It's safe to move because we own
    // the markup — no theme JS references its DOM position.
    var sizeWrapper = item.querySelector('.popup-quick-view__body .selector-wrapper--size-dropdown');

    if (title && title.parentElement !== footInner) {
      footInner.insertBefore(title, submitHolder);
    }
    if (priceBlock && priceBlock.parentElement !== footInner) {
      footInner.insertBefore(priceBlock, submitHolder);
    }
    if (sizeWrapper && sizeWrapper.parentElement !== footInner) {
      footInner.insertBefore(sizeWrapper, submitHolder);
    }

    item.dataset[DONE_FLAG] = '1';
  }

  function scan() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(reorganize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var qbObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  qbObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', function() {
  var radios = document.querySelectorAll('.swatch__input');
  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var checkedRadio = document.querySelector('.swatch__input:checked');
      if (checkedRadio) {
        var colorval = checkedRadio.value;
        showColorImages(colorval);
        var swatchNameEl = document.getElementById('swatchname');
        if (swatchNameEl) swatchNameEl.innerHTML = colorval;
      }
    });
  });

  var checkedRadio = document.querySelector('.swatch__input:checked');
  if (checkedRadio) {
    var colorval = checkedRadio.value;
    showColorImages(colorval);
    var swatchNameEl = document.getElementById('swatchname');
    if (swatchNameEl) swatchNameEl.innerHTML = colorval;
  }
  
});

window.onload = function() {
  var checkedRadio = document.querySelector('.swatch__input:checked');
  if (checkedRadio) {
    var colorval = checkedRadio.value;
    showColorImages(colorval);
  }

// Set "In stock" as the default option in the availability filter
  if (document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").length > 0) {
    
     document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").forEach(function(felement) {
        felement.checked = true;
     });
  }

};

function showColorImages(colorname) {
  var imageallElements = document.querySelectorAll('.imageall');
  imageallElements.forEach(function(element) {
    // The PDP carousel selects variant media through the theme's media handler.
    // Legacy alt-text filtering can hide every slide when images have descriptive alt text.
    if (element.closest('[data-cherry-product]')) return;
    element.classList.add('hideimage');
    element.classList.remove('is-visible');
    if (element.getAttribute('data-color') === colorname) {
      element.classList.remove('hideimage');
      element.classList.add('is-visible');
    }
  });

  if (window.innerWidth < 1008) {
    /*document.body.addEventListener('touchmove', function(e) {
      setTimeout(function() {
        console.log(2)
        var visibleImage = document.querySelector('.imageall.product-single__media-slide.is-selected.hideimage');
        if (visibleImage) {
          
          console.log(3)
          console.log(document.querySelector('.product-single__thumbnail.imageall.is-visible:first-child').getAttribute('data-id'));
          var divElement = document.querySelector('.imageall.product-single__thumbnail.is-visible:first-child');
          var event = new MouseEvent('click', {
            bubbles: 0
          });
          divElement.dispatchEvent(event);
        }
      }, 100);
    });*/
  }
}


function opennewsletter(){
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xwz57X']);
}

(function () {
  function delayButtonVisibility() {
    var buttons = document.querySelectorAll('.template-product button.product__popup__link');
    
    // Show all buttons after 1 second with inline styling
    setTimeout(function() {
      buttons.forEach(function(button) {
        button.style.display = 'inline-block';
      });
    }, 2000);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', delayButtonVisibility);
  } else {
    delayButtonVisibility();
  }
})();

/* ============================================================
   COLLECTION FILTERS: ensure clicking .cherry-collection-filter__control
   or .cherry-collection-filter__radio activates the input
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var control = e.target.closest('.cherry-collection-filter__control, .cherry-collection-filter__radio');
    if (!control) return;

    // If control is a native label with a valid target input, browser handles it natively
    if (control.tagName === 'LABEL' && control.htmlFor && document.getElementById(control.htmlFor)) {
      return;
    }

    var forId = control.getAttribute('for');
    var input = forId ? document.getElementById(forId) : null;
    if (!input) {
      var parent = control.closest('li, .swatch__button');
      input = parent ? parent.querySelector('.filter__input, .collection__sort__input, input[type="checkbox"], input[type="radio"]') : null;
    }

    if (input && !input.disabled) {
      e.preventDefault();
      input.click();
    }
  });
})();

/* ============================================================
   CART ITEM FULFILMENT: pickup vs ship toggle
   - Checks pickup availability per variant via store-availability endpoint
   - Disables "Pick up in store" when pickup is unavailable
   - Allows switching freely between Pickup and Ship when eligible
   - Updates line item properties (_Delivery preference, _Pickup location) via /cart/change.js
   ============================================================ */
(function () {
  var availabilityCache = new Map();
  var availabilityPromises = new Map();

  function getRootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function checkVariantPickupAvailability(variantId) {
    if (!variantId) return Promise.resolve({ available: false, defaultLocation: '' });
    variantId = String(variantId);

    if (availabilityCache.has(variantId)) {
      return Promise.resolve(availabilityCache.get(variantId));
    }
    if (availabilityPromises.has(variantId)) {
      return availabilityPromises.get(variantId);
    }

    var root = getRootUrl();
    var url = new URL(root + 'variants/' + variantId + '/', window.location.origin);
    url.searchParams.set('section_id', 'store-availability');

    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

    var promise = fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('Availability fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var container = doc.querySelector('[data-cherry-pickup-state]');
        if (!container || container.dataset.cherryPickupState !== 'locations') {
          return { available: false, defaultLocation: '' };
        }

        var template = doc.querySelector('template[data-cherry-pickup-cards]');
        var availableInputs = [];
        if (template && template.content) {
          availableInputs = Array.from(template.content.querySelectorAll('[data-cherry-pickup-location]:not(:disabled)'));
        }
        if (!availableInputs.length) {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = template ? template.innerHTML : html;
          availableInputs = Array.from(tempDiv.querySelectorAll('[data-cherry-pickup-location]:not(:disabled)'));
        }

        var isAvailable = availableInputs.length > 0;
        var locationName = isAvailable ? availableInputs[0].value : '';

        return {
          available: isAvailable,
          defaultLocation: locationName
        };
      })
      .catch(function () {
        return { available: false, defaultLocation: '' };
      })
      .then(function (result) {
        availabilityCache.set(variantId, result);
        availabilityPromises.delete(variantId);
        return result;
      });

    availabilityPromises.set(variantId, promise);
    return promise;
  }

  function applyAvailabilityToFulfilment(container, available, defaultLocation) {
    var pickupBtn = container.querySelector('[data-fulfilment-choice="Pick up in store"]');
    var shipBtn = container.querySelector('[data-fulfilment-choice="Ship"]');
    if (!pickupBtn || !shipBtn) return;

    if (available) {
      pickupBtn.disabled = false;
      pickupBtn.classList.remove('is-disabled');
      pickupBtn.removeAttribute('title');
      if (defaultLocation && !container.dataset.pickupLocation) {
        container.dataset.pickupLocation = defaultLocation;
      }
    } else {
      pickupBtn.disabled = true;
      pickupBtn.classList.add('is-disabled');
      pickupBtn.setAttribute('title', 'Pickup is unavailable for this item');

      // If pickup was active for an item that does not offer pickup, revert to Ship
      if (pickupBtn.classList.contains('is-active')) {
        updateFulfilmentChoice(container, 'Ship', true);
      }
    }
  }

  function updateFulfilmentChoice(container, choice, updateCart) {
    if (container.dataset.isUpdating === 'true') return;

    var pickupBtn = container.querySelector('[data-fulfilment-choice="Pick up in store"]');
    var shipBtn = container.querySelector('[data-fulfilment-choice="Ship"]');
    if (!pickupBtn || !shipBtn) return;

    if (choice === 'Pick up in store' && pickupBtn.disabled) return;

    var currentPreference = container.dataset.currentPreference || 'Ship';
    if (choice === currentPreference && !updateCart) return;

    var prevPreference = currentPreference;

    // Optimistically update UI
    if (choice === 'Pick up in store') {
      pickupBtn.classList.add('is-active');
      pickupBtn.setAttribute('aria-pressed', 'true');
      shipBtn.classList.remove('is-active');
      shipBtn.setAttribute('aria-pressed', 'false');
    } else {
      shipBtn.classList.add('is-active');
      shipBtn.setAttribute('aria-pressed', 'true');
      pickupBtn.classList.remove('is-active');
      pickupBtn.setAttribute('aria-pressed', 'false');
    }
    container.dataset.currentPreference = choice;

    if (updateCart === false) return;

    container.classList.add('is-loading');
    container.dataset.isUpdating = 'true';

    var cartItem = container.closest('[data-item]');
    var allItems = Array.from(document.querySelectorAll('.cart-drawer [data-item], [data-cart-page] [data-item]'));
    var domIndex = allItems.indexOf(cartItem) + 1;
    var lineIndex = domIndex > 0 ? domIndex : (parseInt(cartItem && cartItem.getAttribute('data-item-index')) || parseInt(container.dataset.lineIndex) || 1);
    var quantity = parseInt(container.dataset.quantity || (cartItem && cartItem.querySelector('[data-quantity-field]') && cartItem.querySelector('[data-quantity-field]').value) || 1);

    var properties = {};
    var propsScript = container.querySelector('[data-line-properties]');
    if (propsScript) {
      try {
        properties = JSON.parse(propsScript.textContent || '{}');
      } catch (e) {
        properties = {};
      }
    }

    if (choice === 'Pick up in store') {
      properties['_Delivery preference'] = 'Pick up in store';
      properties['_Pickup location'] = container.dataset.pickupLocation || 'Cherry Los Angeles';
    } else {
      properties['_Delivery preference'] = 'Ship';
      properties['_Pickup location'] = '';
    }

    var changeUrl = getRootUrl() + 'cart/change.js';

    fetch(changeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: quantity,
        properties: properties
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart change failed: ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        if (cart && cart.items) {
          var updated = cart.items[lineIndex - 1] || cart.items.find(function (item) {
            return String(item.variant_id) === String(container.dataset.variantId);
          });
          if (updated) {
            if (propsScript) propsScript.textContent = JSON.stringify(updated.properties || {});
            if (cartItem && updated.key) {
              cartItem.setAttribute('data-item', updated.key);
              container.dataset.lineKey = updated.key;
            }
          }
        }
      })
      .catch(function (err) {
        console.error('Failed to update cart fulfilment preference:', err);
        // Revert UI to previous choice on error
        if (prevPreference === 'Pick up in store') {
          pickupBtn.classList.add('is-active');
          pickupBtn.setAttribute('aria-pressed', 'true');
          shipBtn.classList.remove('is-active');
          shipBtn.setAttribute('aria-pressed', 'false');
        } else {
          shipBtn.classList.add('is-active');
          shipBtn.setAttribute('aria-pressed', 'true');
          pickupBtn.classList.remove('is-active');
          pickupBtn.setAttribute('aria-pressed', 'false');
        }
        container.dataset.currentPreference = prevPreference;
      })
      .finally(function () {
        container.classList.remove('is-loading');
        delete container.dataset.isUpdating;
      });
  }

  function initCartFulfilment(root) {
    var containers = (root || document).querySelectorAll('[data-cherry-cart-fulfilment]');
    containers.forEach(function (container) {
      var variantId = container.dataset.variantId;
      if (!variantId) return;

      checkVariantPickupAvailability(variantId).then(function (result) {
        applyAvailabilityToFulfilment(container, result.available, result.defaultLocation);
      });
    });
  }

  // Event delegation for clicking fulfilment options
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cherry-cart-item__fulfilment-option');
    if (!btn) return;

    var container = btn.closest('[data-cherry-cart-fulfilment]');
    if (!container) return;

    var choice = btn.dataset.fulfilmentChoice;
    if (!choice) return;

    e.preventDefault();
    updateFulfilmentChoice(container, choice, true);
  });

  // Lifecycle listeners
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCartFulfilment(document); });
  } else {
    initCartFulfilment(document);
  }

  document.addEventListener('theme:cart:loaded', function () { initCartFulfilment(document); });
  document.addEventListener('theme:cart:added', function () { initCartFulfilment(document); });
  document.addEventListener('theme:cart:open', function () { initCartFulfilment(document); });
  document.addEventListener('shopify:section:load', function (e) { initCartFulfilment(e.target); });

  // MutationObserver to catch dynamically re-rendered cart lines
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        initCartFulfilment(document);
        return;
      }
    }
  });

  var cartContainer = document.querySelector('.cart-drawer, [data-cart-page], #CartDrawer') || document.body;
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
})();

/* ============================================================
   SAFARI MOBILE DRAWER SCROLL & SWIPE FIX
   Ensures that scrollable containers in the mini cart (cart items,
   empty cart recommendations, upsells) and the nav drawer editorial
   slider can be scrolled and swiped cleanly on iOS Safari without
   being blocked by scroll-lock or native image drag gestures.
   ============================================================ */
(function () {
  var SCROLLABLE_SELECTORS = [
    '.cart-drawer__items',
    '.cherry-empty-cart__recommendations',
    '.cherry-cart-recommendations-mobile',
    '.cherry-cart-recommendations__list',
    '.cart__pair',
    '[data-pair-products]',
    '[data-pair-products-holder]',
    '.cherry-drawer',
    '#nav-drawer'
  ];

  function syncScrollLock() {
    var scrollLock = (window.themeVendor && window.themeVendor.ScrollLock) || window.ScrollLock;
    if (scrollLock && typeof scrollLock.addScrollableSelector === 'function') {
      scrollLock.addScrollableSelector(SCROLLABLE_SELECTORS);
    }

    var selectorStr = SCROLLABLE_SELECTORS.join(', ');
    document.querySelectorAll(selectorStr).forEach(function (el) {
      if (!el.hasAttribute('data-scroll-lock-scrollable')) {
        el.setAttribute('data-scroll-lock-scrollable', '');
      }
    });
  }

  function initTouchScrollGuards() {
    document.addEventListener('touchstart', function (e) {
      var scrollable = e.target.closest(SCROLLABLE_SELECTORS.join(', '));
      if (!scrollable) return;
      if (!scrollable.hasAttribute('data-scroll-lock-scrollable')) {
        scrollable.setAttribute('data-scroll-lock-scrollable', '');
      }
    }, { passive: true });
  }

  syncScrollLock();
  initTouchScrollGuards();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncScrollLock);
  }
  window.addEventListener('load', syncScrollLock);
  document.addEventListener('theme:cart:loaded', syncScrollLock);
  document.addEventListener('theme:cart:added', syncScrollLock);
  document.addEventListener('theme:cart:open', function () {
    syncScrollLock();
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var innerScroller = drawer.querySelector('.cart-drawer__items:not(.hidden), .cherry-empty-cart__recommendations');
    if (innerScroller) {
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: innerScroller }));
    }
  });
  document.addEventListener('theme:drawer:open', syncScrollLock);
  document.addEventListener('shopify:section:load', syncScrollLock);
})();

/* ============================================================
   CHERRY NAV DRAWER EDITORIAL SLIDER SCROLL INDICATOR
   Synchronizes the horizontal scroll position of the mobile
   drawer editorial cards slider with the bottom scrollbar thumb.
   Supports touch/wheel scrolling, track tap & drag seeking,
   tab switching, and window resizing.
   ============================================================ */
(function () {
  function initEditorialScrollbars() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;

    var editorialContainers = drawer.querySelectorAll('.cherry-drawer__editorial');
    if (!editorialContainers.length) return;

    editorialContainers.forEach(function (container) {
      if (container.dataset.scrollbarInit === 'true') {
        if (typeof container._updateScrollbar === 'function') {
          container._updateScrollbar();
        }
        return;
      }

      var slider = container.querySelector('.cherry-drawer__editorial-slider');
      var scrollbar = container.querySelector('.cherry-drawer__editorial-scrollbar');
      var thumb = container.querySelector('.cherry-drawer__editorial-scrollbar-thumb');

      if (!slider || !scrollbar || !thumb) return;

      container.dataset.scrollbarInit = 'true';
      var isTicking = false;
      var isPointerDown = false;

      function updateThumb() {
        isTicking = false;

        var scrollWidth = slider.scrollWidth;
        var clientWidth = slider.clientWidth;
        var maxScroll = scrollWidth - clientWidth;

        if (maxScroll <= 0) {
          thumb.style.transform = 'translate3d(0, 0, 0)';
          return;
        }

        var scrollLeft = Math.max(0, Math.min(slider.scrollLeft, maxScroll));
        var progress = scrollLeft / maxScroll;

        var trackWidth = scrollbar.clientWidth || slider.clientWidth || window.innerWidth;
        var thumbWidth = thumb.offsetWidth || 164;
        var maxTravel = Math.max(0, trackWidth - thumbWidth);
        var translateX = progress * maxTravel;

        thumb.style.transform = 'translate3d(' + translateX.toFixed(2) + 'px, 0, 0)';
      }

      container._updateScrollbar = updateThumb;

      function onScroll() {
        if (!isTicking) {
          isTicking = true;
          window.requestAnimationFrame(updateThumb);
        }
      }

      slider.addEventListener('scroll', onScroll, { passive: true });

      // Interactive track tap & drag seeking
      function seekFromEvent(e) {
        var rect = scrollbar.getBoundingClientRect();
        var clientX = e.clientX;
        if (clientX === undefined && e.touches && e.touches[0]) {
          clientX = e.touches[0].clientX;
        }
        if (clientX === undefined) return;

        var clickX = clientX - rect.left;
        var trackWidth = rect.width;
        var thumbWidth = thumb.offsetWidth;
        var maxTravel = Math.max(0, trackWidth - thumbWidth);

        if (maxTravel <= 0) return;

        var targetX = clickX - (thumbWidth / 2);
        var progress = Math.max(0, Math.min(1, targetX / maxTravel));
        var maxScroll = slider.scrollWidth - slider.clientWidth;

        slider.scrollLeft = progress * maxScroll;
      }

      scrollbar.addEventListener('pointerdown', function (e) {
        isPointerDown = true;
        try {
          scrollbar.setPointerCapture(e.pointerId);
        } catch (err) {}
        seekFromEvent(e);
      });

      scrollbar.addEventListener('pointermove', function (e) {
        if (!isPointerDown) return;
        seekFromEvent(e);
      });

      function onPointerUp(e) {
        if (isPointerDown) {
          isPointerDown = false;
          try {
            scrollbar.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      scrollbar.addEventListener('pointerup', onPointerUp);
      scrollbar.addEventListener('pointercancel', onPointerUp);

      // Initial update
      updateThumb();
    });

    if (window.ResizeObserver && !drawer.dataset.scrollbarObserved) {
      drawer.dataset.scrollbarObserved = 'true';
      var ro = new ResizeObserver(function () {
        updateAll();
      });
      editorialContainers.forEach(function (el) {
        ro.observe(el);
      });
      ro.observe(drawer);
    }
  }

  /* ============================================================
     EDITORIAL SLIDER TOUCH & VERTICAL SCROLL COORDINATION
     Allows horizontal swiping of editorial cards while ensuring
     that vertical swiping cleanly and fluidly scrolls #nav-drawer.
     Prevents ScrollLock interference and iOS axis-locking issues.
     ============================================================ */
  function initEditorialSliderTouch() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;

    var sliders = drawer.querySelectorAll('.cherry-drawer__editorial-slider');
    if (!sliders.length) return;

    var momentumRaf = null;
    function stopMomentum() {
      if (momentumRaf) {
        cancelAnimationFrame(momentumRaf);
        momentumRaf = null;
      }
    }

    if (!drawer.dataset.sliderTouchObserved) {
      drawer.dataset.sliderTouchObserved = 'true';
      drawer.addEventListener('touchstart', stopMomentum, { passive: true });
    }

    sliders.forEach(function (slider) {
      if (slider.dataset.touchInit === 'true') return;
      slider.dataset.touchInit = 'true';

      var startX = 0;
      var startY = 0;
      var lastY = 0;
      var lastTime = 0;
      var velocityY = 0;
      var isDetermined = false;
      var isHorizontal = false;
      var isVertical = false;
      var dragPreventClick = false;

      slider.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        if (window.innerWidth >= 990) return;
        stopMomentum();

        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        lastY = touch.clientY;
        lastTime = Date.now();
        velocityY = 0;
        isDetermined = false;
        isHorizontal = false;
        isVertical = false;
      }, { passive: true });

      slider.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        if (window.innerWidth >= 990) return;

        var touch = e.touches[0];
        var diffX = touch.clientX - startX;
        var diffY = touch.clientY - startY;

        if (!isDetermined) {
          var absX = Math.abs(diffX);
          var absY = Math.abs(diffY);
          if (absX > 6 || absY > 6) {
            isDetermined = true;
            dragPreventClick = true;
            if (absX >= absY) {
              isHorizontal = true;
            } else {
              isVertical = true;
            }
          }
        }

        if (isHorizontal) {
          // Horizontal slide: let native horizontal scroll of the slider work.
          // Stop propagation so document-level ScrollLock doesn't preventDefault!
          e.stopPropagation();
        } else if (isVertical) {
          // Vertical swipe: user is scrolling the drawer up/down while touching the image.
          // Stop propagation so ScrollLock doesn't intercept, and preventDefault to avoid iOS axis lock.
          e.stopPropagation();
          if (e.cancelable) {
            e.preventDefault();
          }

          var currentY = touch.clientY;
          var deltaY = lastY - currentY;
          var now = Date.now();
          var dt = Math.max(now - lastTime, 1);

          velocityY = deltaY / dt;
          lastY = currentY;
          lastTime = now;

          drawer.scrollTop += deltaY;
        }
      }, { passive: false });

      function onTouchEnd() {
        if (isVertical && Math.abs(velocityY) > 0.15) {
          var friction = 0.94;
          function inertiaLoop() {
            if (Math.abs(velocityY) < 0.02) {
              stopMomentum();
              return;
            }
            drawer.scrollTop += velocityY * 16;
            velocityY *= friction;
            momentumRaf = requestAnimationFrame(inertiaLoop);
          }
          stopMomentum();
          momentumRaf = requestAnimationFrame(inertiaLoop);
        }

        if (dragPreventClick) {
          setTimeout(function () {
            dragPreventClick = false;
          }, 120);
        }

        isDetermined = false;
        isHorizontal = false;
        isVertical = false;
      }

      slider.addEventListener('touchend', onTouchEnd, { passive: true });
      slider.addEventListener('touchcancel', onTouchEnd, { passive: true });

      slider.addEventListener('click', function (e) {
        if (dragPreventClick) {
          e.preventDefault();
          e.stopPropagation();
          dragPreventClick = false;
        }
      }, true);
    });
  }

  function scrollDrawerToTop() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;
    drawer.scrollTop = 0;
    if (typeof drawer.scrollTo === 'function') {
      try {
        drawer.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      } catch (err) {
        drawer.scrollTop = 0;
      }
    }
    var scrollables = drawer.querySelectorAll(
      '.cherry-drawer__layout, .cherry-drawer__menu-pane, .cherry-drawer__panels, .cherry-drawer__panel, .cherry-drawer__menu, .cherry-drawer__editorial'
    );
    scrollables.forEach(function (el) {
      el.scrollTop = 0;
    });
  }

  function resetActiveEditorialSlider() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;
    var activeSlider = drawer.querySelector('.cherry-drawer__editorial.current .cherry-drawer__editorial-slider');
    if (activeSlider) {
      activeSlider.scrollLeft = 0;
    }
    updateAll();
  }

  function updateAll() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;
    var containers = drawer.querySelectorAll('.cherry-drawer__editorial');
    containers.forEach(function (container) {
      if (typeof container._updateScrollbar === 'function') {
        container._updateScrollbar();
      }
    });
  }

  function observeDrawers() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var target = mutation.target;
          if (target.classList && target.classList.contains('cherry-drawer__editorial')) {
            if (target.classList.contains('current') && typeof target._updateScrollbar === 'function') {
              window.requestAnimationFrame(target._updateScrollbar);
            }
          }
        }
      });
    });

    drawer.querySelectorAll('.cherry-drawer__editorial').forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });

    function handleTabSwitch() {
      scrollDrawerToTop();
      resetActiveEditorialSlider();
      initEditorialSliderTouch();
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          scrollDrawerToTop();
          resetActiveEditorialSlider();
        });
      }
      setTimeout(function () {
        scrollDrawerToTop();
        resetActiveEditorialSlider();
      }, 30);
      setTimeout(function () {
        scrollDrawerToTop();
        resetActiveEditorialSlider();
      }, 100);
      setTimeout(updateAll, 200);
      setTimeout(updateAll, 350);
    }

    drawer.querySelectorAll('.cherry-drawer__tab, [data-tabs-link]').forEach(function (tab) {
      tab.addEventListener('click', handleTabSwitch);
      tab.addEventListener('keyup', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
          handleTabSwitch();
        }
      });
    });

    var tabsBar = drawer.querySelector('.cherry-drawer__tabs');
    if (tabsBar) {
      tabsBar.addEventListener('click', function (e) {
        if (e.target.closest('.cherry-drawer__tab, [data-tabs-link]')) {
          handleTabSwitch();
        }
      });
    }
  }

  function observeDrawerOpen() {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;

    var drawerObserver = new MutationObserver(function () {
      setTimeout(updateAll, 50);
      setTimeout(updateAll, 150);
      setTimeout(updateAll, 300);
      setTimeout(updateAll, 500);
    });

    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });
    drawerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-toggle], [aria-controls="nav-drawer"], .cherry-header__menu-button')) {
        scrollDrawerToTop();
        setTimeout(scrollDrawerToTop, 50);
        setTimeout(updateAll, 50);
        setTimeout(updateAll, 150);
        setTimeout(updateAll, 300);
        setTimeout(updateAll, 500);
      }
    });
  }

  function init() {
    initEditorialScrollbars();
    initEditorialSliderTouch();
    observeDrawers();
    observeDrawerOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    updateAll();
    initEditorialSliderTouch();
  });
  window.addEventListener('resize', updateAll);
  window.addEventListener('orientationchange', updateAll);
  document.addEventListener('theme:drawer:open', function () {
    scrollDrawerToTop();
    initEditorialSliderTouch();
    setTimeout(scrollDrawerToTop, 50);
    setTimeout(updateAll, 50);
    setTimeout(updateAll, 150);
    setTimeout(updateAll, 300);
  });
  document.addEventListener('theme:drawer:opened', function () {
    scrollDrawerToTop();
    initEditorialSliderTouch();
    updateAll();
  });
  document.addEventListener('shopify:section:load', function () {
    initEditorialScrollbars();
    initEditorialSliderTouch();
    observeDrawers();
  });
})();

/* Mobile cart recommendation scroll indicator, including refreshed cart content. */
if (!customElements.get('cherry-cart-recommendations')) {
  customElements.define('cherry-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.list = this.querySelector('.cherry-cart-recommendations__list');
        this.track = this.querySelector('.cherry-cart-recommendations__progress');
        if (!this.list || !this.track) return;
        this.thumb = this.track.querySelector('span');
        this.update = () => {
          const visible = this.list.clientWidth;
          const total = this.list.scrollWidth;
          const travel = total - visible;
          this.track.hidden = visible === 0 || travel <= 1;
          if (this.track.hidden) return;
          const thumbWidth = this.track.clientWidth * visible / total;
          const progress = Math.min(1, Math.max(0, Math.abs(this.list.scrollLeft) / travel));
          this.thumb.style.width = `${thumbWidth}px`;
          this.thumb.style.transform = `translateX(${(this.track.clientWidth - thumbWidth) * progress}px)`;
        };
        this.list.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.list);
        this.observer.observe(this.track);
        this.update();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.list?.removeEventListener('scroll', this.update);
    }
  });
}

/* Fill cart recommendation gaps with Shopify's PDP "You May Also Like" logic. */
(function () {
  var recommendationCache = new Map();
  var pendingRecommendationLists = new WeakSet();
  var preloadedRecommendationImages = new Map();

  function preloadRecommendationImages(list) {
    list.querySelectorAll('img[src]').forEach(function (image) {
      var key = [image.src, image.srcset, image.sizes].join('|');
      if (preloadedRecommendationImages.has(key)) return;
      var preload = new Image();
      preload.sizes = image.sizes;
      preload.srcset = image.srcset;
      preload.src = image.src;
      preloadedRecommendationImages.set(key, preload);
    });
  }

  function fetchRecommendations(productId) {
    if (recommendationCache.has(productId)) return recommendationCache.get(productId);

    var baseUrl = window.theme && window.theme.routes && window.theme.routes.product_recommendations_url;
    if (!baseUrl) baseUrl = '/recommendations/products';
    var url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('section_id', 'api-cherry-cart-recommendations');
    url.searchParams.set('product_id', productId);
    url.searchParams.set('limit', '10');

    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!previewThemeId && window.Shopify && Shopify.designMode && Shopify.theme) {
      previewThemeId = Shopify.theme.id;
    }
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

    var request = fetch(url.toString())
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(documentFragment.querySelectorAll('[data-cart-recommendation-results] .cherry-cart-recommendations__product'));
      })
      .catch(function () { return []; });

    recommendationCache.set(productId, request);
    return request;
  }

  function appendFallbackRecommendations(list, limit, excludedHandles) {
    if (list.querySelector('.cherry-cart-recommendations__product')) return;

    var container = list.closest('.cherry-cart-recommendations');
    var fallbackTemplate = container && container.querySelector('[data-cart-recommendation-fallback]');
    if (!fallbackTemplate) return;

    Array.from(fallbackTemplate.content.querySelectorAll('.cherry-cart-recommendations__product')).some(function (card) {
      var handle = card.dataset.recommendationHandle;
      if (!handle || excludedHandles.has(handle)) return false;
      excludedHandles.add(handle);
      list.appendChild(card.cloneNode(true));
      return list.querySelectorAll('.cherry-cart-recommendations__product').length >= limit;
    });
  }

  function hydrateRecommendationList(list) {
    if (!list || list.dataset.dynamicRecommendationsLoaded === 'true' || pendingRecommendationLists.has(list)) return;

    var productIds = (list.dataset.cartDynamicRecommendations || '').split(',').filter(Boolean);
    var limit = parseInt(list.dataset.cartRecommendationLimit, 10) || 4;
    var excludedHandles = new Set((list.dataset.cartProductHandles || '').split(',').filter(Boolean));
    list.querySelectorAll('[data-recommendation-handle]').forEach(function (card) {
      excludedHandles.add(card.dataset.recommendationHandle);
    });

    if (!productIds.length) {
      appendFallbackRecommendations(list, limit, excludedHandles);
      list.dataset.dynamicRecommendationsLoaded = 'true';
      preloadRecommendationImages(list);
      return;
    }

    pendingRecommendationLists.add(list);

    Promise.all(productIds.map(fetchRecommendations)).then(function (recommendationGroups) {
      var renderedCount = list.querySelectorAll('.cherry-cart-recommendations__product').length;
      var recommendationIndex = 0;

      while (renderedCount < limit) {
        var addedThisRound = false;
        recommendationGroups.forEach(function (group) {
          if (renderedCount >= limit) return;
          var card = group[recommendationIndex];
          if (!card) return;
          var handle = card.dataset.recommendationHandle;
          if (!handle || excludedHandles.has(handle)) return;
          excludedHandles.add(handle);
          list.appendChild(card.cloneNode(true));
          renderedCount += 1;
          addedThisRound = true;
        });
        recommendationIndex += 1;
        if (!addedThisRound && recommendationGroups.every(function (group) { return recommendationIndex >= group.length; })) break;
      }

      appendFallbackRecommendations(list, limit, excludedHandles);

      list.dataset.dynamicRecommendationsLoaded = 'true';
      pendingRecommendationLists.delete(list);
      preloadRecommendationImages(list);
      if (list.isConnected) window.dispatchEvent(new Event('resize'));
    });
  }

  function hydrateCartRecommendations(root) {
    root = root || document;
    root.querySelectorAll('[data-cart-dynamic-recommendations], [data-cart-fallback-recommendations]').forEach(hydrateRecommendationList);
    root.querySelectorAll('[data-cart-drawer-template]').forEach(function (template) {
      template.content.querySelectorAll('.cherry-cart-recommendations__list').forEach(function (list) {
        preloadRecommendationImages(list);
        hydrateRecommendationList(list);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrateCartRecommendations(document); });
  } else {
    hydrateCartRecommendations(document);
  }
  document.addEventListener('theme:cart:loaded', function () { hydrateCartRecommendations(document); });
  document.addEventListener('theme:cart:open', function () { hydrateCartRecommendations(document); });
  document.addEventListener('theme:cart:added', function () { hydrateCartRecommendations(document); });
  document.addEventListener('theme:drawer:open', function () { hydrateCartRecommendations(document); });
  document.addEventListener('theme:drawer:opened', function () { hydrateCartRecommendations(document); });
})();
